<template lang="pug">
.global-action
    .global-action__search
        //- select
        input.field-style.input-astro#find-by-input(
            v-if="isAstro === 'true'"
            :placeholder='findByPlaceholder'
            v-model="key"
            @keyup.enter='inputType($event)'
            :disabled="isDisabled"
            :style="isDisabled ? 'cursor: not-allowed' : ''"
        )

        template(v-else)
            .box-select.relative
                select.block.appearance-none.w-full.leading-tight#find-by-select(@change="changeFindBy($event)" v-model="type" :disabled="isDisabled" :style="isDisabled ? 'cursor: not-allowed' : ''")
                    template(v-if="key_type.length > 0")
                        option(v-for="key in key_type" :value="key.value") {{key.name}}
                .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            //- input
            //- input(placeholder='Tulis nomor target disini...')
            input.field-style#find-by-input(
                :placeholder='findByPlaceholder'
                v-model="key"
                @keyup.enter='inputType($event)'
                :type="type === 'email' ? type : 'text'"
                :disabled="isDisabled"
                :style="isDisabled ? 'cursor: not-allowed' : ''"
            )

        //- button search
        template(v-if="isAstro === 'true'")

            button.flex.items-center.cta-target-search(v-if="load_data_status_overall_data_location.status === 'loading'" @click="cancelRequestAstro()" v-tooltip="'Cancel Request'")
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>

            button.flex.items-center.cta-target-search(v-else @click="search()")
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                span.mobile-only.mr-2 search

        template(v-else)
            button.flex.items-center.cta-target-search(v-if="isResultLoading === true" @click="cancelResultApi()" v-tooltip="'Cancel Request'")
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>

            button.flex.items-center.cta-target-search(v-else @click="search()")
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                span.mobile-only.mr-2 search
</template>

<script>
import { mapState } from 'vuex';
import { encrypt,decrypt } from '@/util/crypto';

export default {
    name: 'shellGlobalAction',
    data: function () {
        return {
            findByPlaceholder: (process.env.VUE_APP_ASTRO === 'true' ? 'Search by MSISDN' : 'Search by MSISDN/NIK/IMSI'),
            type: (process.env.VUE_APP_ASTRO === 'true' ? 'astro' : 'default'),
            key: null,
            isAstro: process.env.VUE_APP_ASTRO,
            isDisabled: false,
        }
    },
    computed: {
        ...mapState([
            'auth_data',
            'profile_subheader',
            'profile_subheader_name',
            // 'record_size',
            // 'from_date',
            // 'end_date',

            'load_data_status_profile_subheader',
            'load_data_status_profile_subheader_name',
            // 'load_data_status_single_target_detail', // detail target only
            'load_data_status_overall_app_usage',
            'load_data_status_overall_data_location',
            'load_data_status_location',
            // 'load_data_status_location_count',
            'load_data_status_browsing',
            // 'load_data_status_browsing_count',
            'load_data_status_device_history',
            'load_data_status_tethered_device',
            'load_data_status_possible_location',
            'load_data_status_aerial_log',
            'load_data_status_signal_status',
            'load_data_status_profile',
            // 'load_data_status_profile_count',
            'load_data_status_get_contact',
            'load_data_status_tokped',
            'load_data_status_travel_history',
            'load_data_status_vehicles',
            'load_data_status_etle',
            'load_data_status_bank_account',
            'load_data_status_personal_identity',
            'load_data_status_travel',
            // 'load_data_status_pln',
        ]),
        thisKey() {
            return this.$route.params.key;
        },
        isKey() {
            return this.thisKey ? true : false;
        },
        isResultLoading() {
            let result = false;
            if (
                this.load_data_status_profile_subheader.status === 'loading' ||
                this.load_data_status_profile_subheader_name.status === 'loading' ||
                this.load_data_status_overall_app_usage.status === 'loading' ||
                this.load_data_status_overall_data_location.status === 'loading' ||
                this.load_data_status_location.status === 'loading' ||
                this.load_data_status_browsing.status === 'loading' ||
                this.load_data_status_device_history.status === 'loading' ||
                this.load_data_status_tethered_device.status === 'loading' ||
                this.load_data_status_possible_location.status === 'loading' ||
                this.load_data_status_aerial_log.status === 'loading' ||
                this.load_data_status_signal_status.status === 'loading' ||
                this.load_data_status_profile.status === 'loading' ||
                this.load_data_status_get_contact.status === 'loading' ||
                this.load_data_status_tokped.status === 'loading' ||
                this.load_data_status_travel_history.status === 'loading' ||
                this.load_data_status_vehicles.status === 'loading' ||
                this.load_data_status_etle.status === 'loading' ||
                this.load_data_status_bank_account.status === 'loading' ||
                this.load_data_status_travel.status === 'loading' ||
                // this.load_data_status_pln.status === 'loading' ||
                this.load_data_status_personal_identity.status === 'loading'
            )
                result = true;

            return result;
        },
        route_name() {
            return this.$route.matched[0] ? this.$route.matched[0].name : null;
        },
        key_type() {
            let key_type = [];
            let role_label = this.auth_data.role.label;
            let role_module = this.auth_data.role.module;
            
            if (this.isAstro === 'true') {
                key_type.push({
                    value: 'astro',
                    name: 'MSISDN',
                });
            } else {
                if (role_label === 'superadmin' || (role_module && role_module.length > 0)) {
                    // default
                    if(this.checkFeatureByAcl(this.auth_data,'key_type','msisdn_nik_imsi')){
                        key_type.push({
                            value: 'default',
                            name: 'MSISDN/NIK/IMSI',
                        });
                    }

                    // imei_sv
                    if(this.checkFeatureByAcl(this.auth_data,'key_type','imei_sv')){
                        key_type.push({
                            value: 'imei-sv',
                            name: 'IMEI-SV',
                        });
                    }

                    // nopol
                    if(this.checkFeatureByAcl(this.auth_data,'key_type','nopol')){
                        key_type.push({
                            value: 'nopol',
                            name: 'Plat Nomor',
                        });
                    }

                    // name
                    if(this.checkFeatureByAcl(this.auth_data,'key_type','name')){
                        key_type.push({
                            value: 'name',
                            name: 'Name',
                        });
                    }

                    // email
                    if(this.checkFeatureByAcl(this.auth_data,'key_type','email')){
                        key_type.push({
                            value: 'email',
                            name: 'Email',
                        });
                    }

                    // univ-name
                    if(this.checkFeatureByAcl(this.auth_data,'key_type','univ_name')){
                        key_type.push({
                            value: 'univ-name',
                            name: 'University Name',
                        });
                    }
                }
            }

            return key_type;
            
        },
    },
    watch: {
        findByPlaceholder() {},
        thisKey() {
            // if (newData)
                this.decryptData();
        },
        isKey() {},
        isResultLoading(newData) {
            if (newData === true) {
                this.isDisabled = true;
            } else {
                this.isDisabled = false;
            }
        },
        load_data_status_overall_data_location(newData) {
            // console.log('watch load_data_status_overall_data_location')
            // console.log(newData.status)
            if (this.isAstro) {
                // if (this.load_data_status_overall_data_location.status === 'loading')
                if (newData.status === 'loading')
                    this.isDisabled = true;
                    // this.isDisabled = 'disabled';
                else
                    this.isDisabled = false;
            }

            // console.log('this.isDisabled')
            // console.log(this.isDisabled)

        },
        // route_name(newData){
        //     if (newData != 'PageResult')
        //         this.key = null
        // }
    },
    methods: {
        validateEmail(email) {
            /* eslint-disable no-useless-escape */
            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        // changeFindBy(e) {
        changeFindBy(focus=true) {
            // if (e.target.value === 'default') {
            // if (this.type === 'default') {
            //     this.findByPlaceholder = 'Search by MSISDN/NIK/IMSI';
            // } else if (this.type === 'imei-sv') {
            //     this.findByPlaceholder = 'Search by IMEI-SV';
            // } else {
            //     this.findByPlaceholder = 'Search by Plat Nomor';
            // }

            if (this.isAstro === 'true') {
                this.findByPlaceholder = 'Search by MSISDN';
            } else {
                switch(this.type) {
                    case 'imei-sv':
                        this.findByPlaceholder = 'Search by IMEI-SV';
                    break;
                    case 'nopol':
                        this.findByPlaceholder = 'Search by Plat Nomor';
                    break;
                    case 'name':
                        // this.findByPlaceholder = 'Search by Name';
                        this.findByPlaceholder = 'Ex : “Budi Sleman 1992”';
                    break;
                    case 'email':
                        this.findByPlaceholder = 'Search by Email';
                    break;
                    case 'univ-name':
                        this.findByPlaceholder = 'Search University';
                    break;
                    default:
                        this.findByPlaceholder = 'Search by MSISDN/NIK/IMSI';
                }
            }

            if (focus)
                document.getElementById('find-by-input').focus();
        },
        inputType(e) {
            // submit search
            if (e.keyCode === 13) {
                this.search();
                // remove focus on input
                e.target.blur();
            }
        },
        search() {
            if (this.key !== null && this.key !== '') {

                // reset global filter (need to check with api)
                // const default_date = this.$store.getters.getDefaultDate();
                const record_size = this.$store.getters.getDefaultRecordSize;

                this.$store.commit('setRecordSize', record_size);
                // this.$store.commit('setFromDate', default_date.from_date);
                // this.$store.commit('setEndDate', default_date.end_date);
                
                // this.$store.commit('setFromDatePerMenu', ['all', default_date.from_date]);

                // console.log("this.$store.commit('setFromDatePerMenu', ['all', default_date.from_date])")
                // console.log(default_date.from_date)

                // this.$store.commit('setEndDatePerMenu', ['all', default_date.end_date]);

                

                // add astro option
                // if (this.type === 'default') {
                if (this.type === 'default' || (this.type === 'astro' && this.isAstro === 'true')) {
                    // console.log('select value as default (MSISDN/NIK/IMSI)')
                    // console.log(this.type);

                    // var check = input.value.replace(/^\d/, '');
                    var check = this.key;
                    var length = check.length;
                    var firstTwo = check.substr(0, 2);
                    var firstThree = check.substr(0, 3);

                    var key = null;
                    var type = null;

                    // astro only use msisdn
                    if (this.type === 'astro' && this.isAstro === 'true') {
                        if ((length >= 10 && length<=14) && (firstTwo == '08' || firstTwo == '62' || firstTwo == '+6')) {
                            // console.log('input as astro msisdn')

                            key = check;
                            type = 'msisdn';

                            if (firstTwo == "08") {
                                key = "62" + check.substr(1);
                            } else if(firstTwo == "+6") {
                                key = check.substr(1);
                            }
                        }

                    } else {
                        if (length === 16) {
                            // console.log('input as nik')
                            key = check;
                            type = 'nik';
                        } else if ((length >= 10 && length<=14) && (firstTwo == '08' || firstTwo == '62' || firstTwo == '+6')) {
                            // console.log('input as msisdn')

                            key = check;
                            type = 'msisdn';

                            if (firstTwo == "08") {
                                key = "62" + check.substr(1);
                            } else if(firstTwo == "+6") {
                                key = check.substr(1);
                            }
                        } else if (firstThree == '510') {
                            // console.log('input as imsi')
                            key = check;
                            type = 'imsi';
                        } else {
                            // Selain NIK/MSISDN/IMSI
                            // console.log('default: no type found!')
                            
                            // alert('default: no type found!')
                            // return;
                            this.$swal.fire({
                                icon: 'error',
                                title: 'No type found on '+ this.findByPlaceholder +'!',
                                // timer: 3000,
                                onClose: document.getElementById('find-by-input').focus(),
                            });
                        }
                    }

                    if (key === null)
                        return;

                    // this.$store.state.key = key;
                    // this.$store.state.type = type;
                    

                    // if (this.$route.matched[0].path === '/result') {
                    //     this.$store.dispatch('getResultData', [key, type]);
                    // } else {
                    //     this.$router.push({ name: 'result-overall' });
                    //     this.$store.dispatch('getResultData', [key, type]);
                    // }

                    this.processSearch(key, type);

                // imei-sv
                } else if (this.type === 'imei-sv') {
                    key = this.key;
                    // type = 'imei-sv';
                    type = this.type;
                    // console.log('select value as IMEI-SV')

                    this.processSearch(key, type);

                // univ-name
                } else if (this.type === 'univ-name') {
                    key = this.key;
                    type = this.type;

                    this.processSearch(key, type);
                
                // nopol
                } else if (this.type === 'nopol') {
                    key = this.key;
                    // type = 'nopol';
                    type = this.type;
                    // console.log('select value as nopol')

                    this.processSearch(key, type);

                // name
                } else if (this.type == 'email') {
                    if (!this.validateEmail(this.key)) {
                        // this.error_username = 'The email must be a valid email address.';
                        this.$swal.fire({
                            title: 'Email must be a valid email address.',
                            text: 'Ex: name@domain.com',
                            icon: 'warning',
                            // timer: 3000,
                        });
                        return;
                    } else {
                        key = this.key;
                        // type = 'name';
                        type = this.type;
                        // console.log('select value as email')

                        this.processSearch(key, type);
                    }
                } else {
                    if (this.validateEmail(this.key)) {
                        // this.error_username = 'The email must be a valid email address.';
                        this.$swal.fire({
                            title: "Keyword containt email format, please don't use email.",
                            text: 'Ex: Budi or Budi Santoso',
                            icon: 'warning',
                            // timer: 3000,
                        });
                        return;
                    }

                    key = this.key;
                    // type = 'name';
                    type = this.type;
                    // console.log('select value as name')

                    this.processSearch(key, type);
                }


            } else {
                // console.log('this.key is empty')

                this.$swal.fire({
                    icon: 'error',
                    title: 'Input '+ this.findByPlaceholder +' is required!',
                    // timer: 3000,
                    onClose: document.getElementById('find-by-input').focus(),
                });
            }

            EventEmit.$emit('mobileSearchClose')
        },
        cancelRequestAstro() {
            this.$store.dispatch('cancelForceOverallDataLocation');
        },
        async cancelResultApi() {
            // calcel all request
            await this.$store.dispatch('cancelResultApi');

            // set empty status & value
            await this.$store.dispatch('setEmptyResultData', [true, {cancel: null, status: 'failed', code: null}, 'all', true]);            
        },
        async processSearch(key, type) {
            // if (this.$route.matched[0].path === '/result') {
            //     this.$store.dispatch('getResultData', [key, type]);
            // } else {
            //     this.$router.push({ name: 'result-overall' });
            //     this.$store.dispatch('getResultData', [key, type]);
            // }

            // console.log('====== on process search')
            // console.log(this.$route.matched[0].name)
            // console.log(this.$route.params.key)
            // console.log(type)

            // cancel all result request api in any
            // await this.$store.dispatch('cancelResultApi');
            
            // await EventEmit.$emit('fromGlobalSearch');
            
            await this.cancelResultApi();

            // add after trigger api on click menu
            await this.$store.dispatch('setEmptyResultData', []);
            await this.$store.dispatch('clearApiResp')

            // search by name
            if (type === 'name') {
                this.$router.push({ name: 'PageName', params: { key: encrypt(key + '&&' + type) } });

            // search by name
            } else if (type === 'univ-name') {
                this.$router.push({ name: 'PageUnivName', params: { key: encrypt(key + '&&' + type) } });

            // check for astro
            } else if (this.isAstro === 'true') {
                this.$router.push({ name: 'result-recent-location', params: { key: encrypt(key + '&&' + type) } });

            } else if (type !== 'nopol') {
                // this.$router.push({ name: 'result-recent-location', params: { key: encrypt(key + '&&' + type) } });
                // console.log(this.$router.currentRoute)

                // page result or page target detail
                // if (this.$route.matched[0].name === 'PageResult' || this.$route.matched[0].name === 'PageTargetDetail') {
                //     // this.$route.params.key = encrypt(key + '&&' + type);
                //     // console.log('===== after set key on routes');
                //     // console.log(this.$route.params.key);
                    
                //     // this.$router.push({ name: 'result-recent-location', params: { key: encrypt(key + '&&' + type) } });

                //     // this.$store.dispatch('getResultData', [key, type]);

                //     // -------------------------------------------------

                    
                //     // temporary, vehicle exlucde from other
                //     if (this.$route.matched[1].name !== 'result-vehicles') {
                //         this.$router.push({ name: this.$route.matched[1].name, params: { key: encrypt(key + '&&' + type) } });
                //     } else {

                //         let route_name = '';

                //         if (type === 'msisdn' || type === 'imsi' || type === 'imei-sv') {
                //             route_name = 'result-recent-location';
                //         } else if (type === 'nik') {
                //             route_name = 'result-profile';
                //         // } else if (type === 'nopol') {
                //         //     route_name = 'result-vehicles';
                //         } else if (type === 'email') {
                //             route_name = 'result-marketplace';
                //         }

                //         // this.$router.push({ name: 'result-recent-location', params: { key: encrypt(key + '&&' + type) } });

                //         this.$router.push({ name: route_name, params: { key: encrypt(key + '&&' + type) } });
                //     }
                // } else {
                    let route_name = '';

                    if (type === 'msisdn' || type === 'imsi' || type === 'imei-sv') {
                        route_name = 'result-recent-location';
                    } else if (type === 'nik') {
                        route_name = 'result-profile';
                    // } else if (type === 'nopol') {
                    //     route_name = 'result-vehicles';
                    } else if (type === 'email') {
                        // route_name = 'result-marketplace';
                        route_name = 'result-personal-identity';
                    }

                    // this.$router.push({ name: 'result-recent-location', params: { key: encrypt(key + '&&' + type) } });

                    this.$router.push({ name: route_name, params: { key: encrypt(key + '&&' + type) } });
                // }
            } else {
                // this.$router.push({ name: 'vehicles', params: { key: encrypt(key + '&&' + type) } });

                // console.log('search nopol');

                this.$router.push({ name: 'result-vehicles', params: { key: encrypt(key + '&&' + type) } });
            }
        },
        decryptData() {
            if (this.isKey) {
                let decrypt_data = decrypt(this.thisKey);
                decrypt_data = decrypt_data.split('&&');
                // console.log(decrypt_data);

                var key = decrypt_data[0];
                var type = decrypt_data[1];

                this.key = key;

                let selected = null;

                switch(type) {
                    case 'imei-sv':
                        selected = 'imei-sv';
                        break;
                    case 'nopol':
                        selected = 'nopol';
                        break;
                    case 'name':
                        selected = 'name';
                        break;
                    case 'email':
                        selected = 'email';
                        break;
                    case 'univ-name':
                        selected = 'univ-name';
                        break;
                    default:
                        // check is astro
                        if (this.isAstro === 'true') {
                            selected = 'astro';
                        } else {
                            selected = 'default';
                        }
                } 

                // document.querySelector('#find-by-select [value="' + selected + '"]').selected = true;
                this.type = selected;
                this.changeFindBy(false);

                // return { key: key, type: type };
            }
        },
        // checkFeatureByAcl(user, module, func) {
        //     if (user && user.role && user.role.label === 'superadmin') {
        //         return true
        //     } else {
        //         let funcArr = []
        //         try {
        //             let moduleACL = user.role.module.filter(function(item) {
        //                 return item.label.toUpperCase() === module.toUpperCase();
        //             });
        //             if (func == null) {
        //                 funcArr = moduleACL
        //             } else {  
        //                 funcArr = moduleACL[0].function.filter(function(item) {
        //                     return item.label.toUpperCase() === func.toUpperCase();
        //                 });
        //             }
        //         } catch (error) {
        //             console.log('error checkFeatureByAcl')
        //             console.log(error)
        //         }
        //         return funcArr.length? true : false
        //     }
        // }
    },
    mounted() {
        // if (this.$route.params.key !== null && this.$route.params.key !== undefined) {
        //     this.decryptData();
        // }
        // if (this.isKey)
        this.decryptData();
        // console.log('mounted')
        // console.log(this.route)
    },
}
</script>

